import { RequiredTrainingKey } from '@uplift/api';

// The Relias learner portal's required-training-plans page; this is a generic viewer URL, not
// an SSO flow, so it does not require any backend-issued token or course id.
export const RELIAS_TRAINING_LAUNCH_URL = 'https://betterhelp.training.reliaslearning.com/new/en/training/required-training/training-plans';

export enum TrainingCadence {
  annual = 'annual',
  oneTime = 'one_time',
}

export type RequiredTrainingMetadata = {
  label: string;
  estimatedMinutes: number;
  cadence: TrainingCadence;
};

// Keyed by the stable RequiredTrainingKey (not the raw Relias course_id, which the backend
// already resolves to a key for us) — purely cosmetic display config, so it's fine for this to
// live frontend-side, but it should never need to know actual Relias course IDs.
const METADATA_BY_KEY: Record<RequiredTrainingKey, RequiredTrainingMetadata> = {
  [RequiredTrainingKey.hipaaAndSecurity]: { label: 'HIPAA & Security training', estimatedMinutes: 30, cadence: TrainingCadence.annual },
  [RequiredTrainingKey.prescriber]: { label: 'Prescriber training', estimatedMinutes: 60, cadence: TrainingCadence.oneTime },
};

export const getTrainingMetadata = (training: { key: RequiredTrainingKey | null }): RequiredTrainingMetadata | null =>
  training.key ? METADATA_BY_KEY[training.key] ?? null : null;
